import { FaRegEyeSlash, FaRegEye } from 'react-icons/fa';
import modalCloseIcon from "../../src/assets/icons/modal-back-icon.svg"
import uploadIcon from "../../src/assets/icons/upload-icon.svg"
import eventDateIcon from "../../src/assets/icons/event-date-icon.svg"
import eventTimeIcon from "../../src/assets/icons/event-time-icon.svg"
import teamsIcon from "../../src/assets/icons/teams-icon.svg"






export const Icons = () => {
  return (
    {
      FaRegEyeSlash,
      FaRegEye,
      modalCloseIcon,
      uploadIcon,
      eventDateIcon,
      eventTimeIcon,
      teamsIcon
    }
  );
};